<ng-template [ngIf]="routerLink" [ngIfThen]="linkRef" [ngIfElse]="nolinkRef"></ng-template>
<ng-template #linkRef>
  <a *ngIf="isCourseService" [routerLink]="routerLink" [attr.title]="'[' + sequenceNumber + '/' + sequenceTotal + '] ' + title">[{{sequenceNumber}}/{{ sequenceTotal}}] {{ title }}</a>
  <a *ngIf="isOngoingService" [routerLink]="routerLink" [attr.title]="title">{{ title }}</a>
  <a *ngIf="isOneTimeService" [routerLink]="routerLink" [attr.title]="title">{{ title }}</a>
</ng-template>
<ng-template #nolinkRef>
  <span *ngIf="isCourseService">[{{sequenceNumber}}/{{ sequenceTotal}}] {{ title }}</span>
  <span *ngIf="isOngoingService">{{ title }}</span>
  <span *ngIf="isOneTimeService">{{ title }}</span>
</ng-template>
